import type { BookSettingPayload } from '@/api/services/book-setting.service'
import type { GuideSettingsState } from '@/lib/guides/guide-settings-precedence'
import type { DocumentLayoutState } from '../types/document-layout-state'

export function getDefaultGuideSettingsFromBookPayload(
  payload: BookSettingPayload | null | undefined
): GuideSettingsState | null {
  if (!payload) return null

  const columns = getPositiveNumber(payload.columnNum)
  const rows = getPositiveNumber(payload.rowNum)
  const colGutter = getNonNegativeNumber(payload.columnGutter)
  const rowGutter = payload.linkedGutterValues ? colGutter : getNonNegativeNumber(payload.rowGutter)

  if (columns == null || rows == null || colGutter == null || rowGutter == null) {
    return null
  }

  return {
    columns: Math.round(columns),
    rows: Math.round(rows),
    colGutter,
    rowGutter,
  }
}

export function getPositiveNumber(value: unknown): number | null {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null
  if (value <= 0) return null
  return value
}

export function getNonNegativeNumber(value: unknown): number | null {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null
  if (value < 0) return null
  return value
}

export function getNextDocumentLayout(
  payload: BookSettingPayload,
  prev: DocumentLayoutState
): DocumentLayoutState {
  const nextTrimWidth = getPositiveNumber(payload.bookTrimSize?.width) ?? prev.pageTrimWidth
  const nextTrimHeight = getPositiveNumber(payload.bookTrimSize?.height) ?? prev.pageTrimHeight

  return {
    ...prev,
    pageTrimWidth: nextTrimWidth,
    pageTrimHeight: nextTrimHeight,
    marginInside: getNonNegativeNumber(payload.insideMargin) ?? prev.marginInside,
    marginOutside: getNonNegativeNumber(payload.outsideMargin) ?? prev.marginOutside,
    marginTop: getNonNegativeNumber(payload.topMargin) ?? prev.marginTop,
    marginBottom: getNonNegativeNumber(payload.bottomMargin) ?? prev.marginBottom,
  }
}
